(() => {
  const boundAttr = 'data-ids-bound';
  const mobileQuery = '(max-width: 767.98px)';
  const mod = (value, length) => ((value % length) + length) % length;

  const bindSection = (root) => {
    if (!root || root.hasAttribute(boundAttr)) return;
    root.setAttribute(boundAttr, 'true');

    const track = root.querySelector('[data-ids-track]');
    const slots = Array.from(root.querySelectorAll('[data-ids-item]'));
    const panels = Array.from(root.querySelectorAll('[data-ids-panel]'));
    const dots = Array.from(root.querySelectorAll('[data-ids-dot]'));
    const mouseMoveEnabled = root.dataset.idsMousemove !== 'false';
    const centerFixedModeEnabled = root.dataset.idsCenterFixed !== 'false';
    const lockUntilSeen = root.dataset.idsLockUntilSeen === 'true';

    if (!track || slots.length === 0) return;

    const slotCount = Math.min(3, slots.length);
    const slotCenter = Math.floor(slotCount / 2);
    const blockCount = slots.length;
    const mediaHtml = slots.map((slot) => slot.innerHTML);

    let slotToBlock = Array.from({ length: slotCount }, (_, i) => i);
    let wheelLocked = false;
    let touchStartX = null;
    let touchMoved = false;
    let hoverSlotIndex = null;
    let freeActiveBlock = slotCenter;
    const seenCenter = new Set();
    let scrollUnlocked = !lockUntilSeen;

    const render = () => {
      const activeSlot = centerFixedModeEnabled
        ? (hoverSlotIndex == null ? slotCenter : hoverSlotIndex)
        : slotToBlock.indexOf(freeActiveBlock);
      for (let i = 0; i < slotCount; i += 1) {
        const blockIndex = slotToBlock[i];
        const slot = slots[i];
        if (!slot) continue;
        slot.innerHTML = mediaHtml[blockIndex];
        slot.dataset.sourceIndex = String(blockIndex);
        slot.classList.toggle('is-active', i === activeSlot);
      }

      const activeCenterBlock = slotToBlock[slotCenter];
      seenCenter.add(activeCenterBlock);
      if (lockUntilSeen && seenCenter.size >= blockCount) {
        scrollUnlocked = true;
      }
      const activeBlock = slotToBlock[activeSlot];
      panels.forEach((panel, i) => panel.classList.toggle('is-active', i === activeBlock));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeBlock));
    };

    const rotate = (direction) => {
      // direction > 0: right -> center, center -> left, left -> right
      if (direction > 0) {
        slotToBlock = [slotToBlock[2], slotToBlock[0], slotToBlock[1]];
      } else {
        slotToBlock = [slotToBlock[1], slotToBlock[2], slotToBlock[0]];
      }
      render();
    };

    const setCenterBlock = (blockIndex) => {
      const current = slotToBlock[slotCenter];
      if (current === blockIndex) return;
      const currentPos = slotToBlock.indexOf(blockIndex);
      if (currentPos === -1) return;
      // rotate shortest within 3 slots
      if ((currentPos + 1) % 3 === slotCenter) rotate(-1);
      else rotate(1);
    };

    const onWheel = (event) => {
      if (window.matchMedia(mobileQuery).matches) return;
      if (Math.abs(event.deltaY) < 3) return;

      if (!centerFixedModeEnabled) {
        event.preventDefault();
        if (wheelLocked) return;
        wheelLocked = true;
        freeActiveBlock = mod(freeActiveBlock + (event.deltaY > 0 ? 1 : -1), blockCount);
        render();
        window.setTimeout(() => {
          wheelLocked = false;
        }, 180);
        return;
      }

      if (!scrollUnlocked) {
        event.preventDefault();
      }

      if (wheelLocked) return;
      wheelLocked = true;
      rotate(event.deltaY > 0 ? 1 : -1);
      window.setTimeout(() => {
        wheelLocked = false;
      }, 180);
    };

    const onTouchStart = (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchMoved = false;
    };

    const onTouchMove = () => {
      touchMoved = true;
    };

    const onTouchEnd = (event) => {
      if (touchStartX == null) return;
      const touch = event.changedTouches[0];
      const endX = touch ? touch.clientX : touchStartX;
      const distance = endX - touchStartX;
      const threshold = 24;

      if (Math.abs(distance) >= threshold) {
        if (centerFixedModeEnabled) {
          rotate(distance < 0 ? 1 : -1);
        } else {
          freeActiveBlock = mod(freeActiveBlock + (distance < 0 ? 1 : -1), blockCount);
          render();
        }
      } else if (!touchMoved) {
        const rect = track.getBoundingClientRect();
        const ratio = rect.width > 0 ? Math.min(0.999999, Math.max(0, (endX - rect.left) / rect.width)) : 0;
        const slotIndex = Math.floor(ratio * slotCount);
        const blockIndex = slotToBlock[slotIndex];
        if (centerFixedModeEnabled) {
          setCenterBlock(blockIndex);
        } else {
          freeActiveBlock = blockIndex;
          render();
        }
      }

      touchStartX = null;
      touchMoved = false;
    };

    if (mouseMoveEnabled) {
      for (let i = 0; i < slotCount; i += 1) {
        const slot = slots[i];
        if (!slot) continue;
        slot.addEventListener('mouseenter', () => {
          hoverSlotIndex = i;
          render();
        });
      }
      root.addEventListener('mouseleave', () => {
        hoverSlotIndex = null;
        render();
      });
    }

    for (let i = 0; i < slotCount; i += 1) {
      const slot = slots[i];
      if (!slot) continue;
      slot.addEventListener('click', () => {
        if (centerFixedModeEnabled) {
          setCenterBlock(slotToBlock[i]);
        } else {
          freeActiveBlock = slotToBlock[i];
          render();
        }
      });
    }

    root.addEventListener('wheel', onWheel, { passive: false });
    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: true });
    track.addEventListener('touchend', onTouchEnd, { passive: true });

    render();
  };

  const init = () => {
    document.querySelectorAll('[data-ids]').forEach(bindSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-ids]').forEach(bindSection);
  });
})();